/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false,
    header: false
  },
  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      required: false,
      type: {
        root: () => getRootUrl() + GlobalSettings.dcImageRoot
      },
      hint: 'standard_size_512x512' // 尺寸最好为512*512
    },
    displayName: 'Picture',
    header: true
  },
  // icon: {
  //   displayName: 'icon',
  //   tableConfig: {
  //     overwrite: true,
  //   },
  // },
  name: {
    displayName: 'allergName'
  },

  shortName: {
    displayName: 'shortName'
  },
  removeImage: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  selectedShowName: {
    form: false,
    header: false
  }
}
const config = {
  add: function (item) {
    if (item.file) {
      item.image = item.file
    }
    return hillo.postWithUploadFile('Dishes.php?op=addAllergen', item, {
      showLoading: true
    })
  },
  edit: function (item) {
    if (item.file) {
      item.image = item.file
    }
    return hillo.postWithUploadFile('Dishes.php?op=updateAllergen', item, {
      showLoading: true
    })
  },
  remove: function (id) {
    return hillo.post('Dishes.php?op=deleteAllergen', { id })
  },
  load: async function (filter) {
    return (await hillo.get('Dishes.php', {
      op: 'showAllAllergen',
      ...filter
    }))
      .content.map(it => {
        it.selectedShowName = '(' + it.shortName + ')' + it.name
        return it
      })
  }
}

export async function removeAllergenImage (id) {
  return (await hillo.post('Dishes.php?op=removeAllergenImage', { id }))
}

export default IKDataEntity.ModelFactory(entity, config)
